// apolo/src/components/code/sessionWorkspace/headerMenuConfig.js — P5-T02 (code-tab-lift).
//
// Static header-menu configuration (the right-rail "Menu" groups) extracted from
// SessionWorkspace so the shell no longer carries ~55 lines of menu data + a dozen
// icon imports that are used nowhere else. Pure data (group label + { id, label, icon,
// shortcut? } tabs); the component just renders HEADER_MENU_GROUPS.
import {
  BookOpen, Bot, Brain, CheckSquare, FileText, FlaskConical, GitBranch, GraduationCap,
  Lightbulb, Map as MapIcon, Route, ScrollText, Search, Sparkles, Terminal as TerminalIcon,
} from 'lucide-react';

// Overflow popover groups — grouped by intent so the menu scans clean even
// when carrying 9+ entries.
export const OVERFLOW_GROUPS = [
  {
    label: 'Plan',
    tabs: [
      { id: 'plan', label: 'Plan', icon: MapIcon },
      { id: 'dag', label: 'DAG Tasks', icon: Route },
      { id: 'worktree', label: 'Worktree', icon: GitBranch },
      { id: 'todos', label: 'Todos', icon: CheckSquare },
    ],
  },
  {
    label: 'Knowledge',
    tabs: [
      { id: 'memory', label: 'Memory', icon: BookOpen },
      { id: 'grep', label: 'Grep', icon: Search },
      // (Pedro) codemap removed — canonical "Mapa do Código" is the left sidebar.
      { id: 'brain', label: 'Brain', icon: Brain, shortcut: '⇧⌘B' },
    ],
  },
  {
    label: 'AI',
    tabs: [
      { id: 'learning', label: 'Learning', icon: Sparkles, shortcut: '⇧⌘L' },
      { id: 'agents', label: 'Agents', icon: Bot, shortcut: '⇧⌘A' },
      // (Pedro) Adapters removed from the Menu — it's the top-right "Adapters ⌘E".
    ],
  },
  {
    label: 'Self-improve',
    tabs: [
      { id: 'rules', label: 'Rules', icon: ScrollText },
      { id: 'session-rules', label: 'Session', icon: Lightbulb },
      { id: 'learned-rules', label: 'Evaluator', icon: GraduationCap },
      { id: 'tests', label: 'Tests', icon: FlaskConical },
    ],
  },
];

// Tabs essenciais — abertos via aba Menu do rail direito.
// (Pedro: "features repetidas") — Preview + Diff dropped from the Menu: the
// header 👁 opens the dedicated Preview panel and the "Canvas" rail tab IS the
// diff surface, so listing them here just duplicated those. Still reachable via
// ⇧⌘P / ⇧⌘D for power users (the SidePanel tabs themselves are unchanged).
export const ESSENTIAL_TABS = [
  { id: 'files', label: 'Files', icon: FileText, shortcut: '⇧⌘F' },
  { id: 'terminal', label: 'Terminal', icon: TerminalIcon, shortcut: '⌘`' },
];

export const HEADER_MENU_GROUPS = [
  { label: 'Essenciais', tabs: ESSENTIAL_TABS },
  ...OVERFLOW_GROUPS,
];
